import { Expose } from "class-transformer";

export class SelfPortalPageEntity {
  @Expose()
  id!: string;

  @Expose()
  url!: string;
}
